import React from 'react';
import { Paragraph } from '../pararaph/pararaph';
import { jsx as _jsx } from "react/jsx-runtime";
export var Description = function Description(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/_jsx(Paragraph, {
    small: true,
    children: children,
    className: className
  });
};